import React, { useState } from "react";
import { Layout, Menu, Breadcrumb } from "antd";

const { Content, Sider } = Layout;

const graphs = [
  /* Interior */
  {
    id: "graph1",
    title: "Evolución en el tiempo",
    menuTitle: "Interior",
    text: `En 2023, la mitad de las niñas y niños (54%) que estaban matriculados en la educación parvularia pública o subvencionada pintó o escribió al 
          menos una vez a la semana, en el último mes. A un 37% de las niñas y niños les leyeron cuentos o historias y un 34% cantó o tocó un 
          instrumento. Estas tres actividades se han mantenido relativamente estables en el tiempo.`,
    link: "https://public.flourish.studio/visualisation/23729696/embed",
  },
  {
    id: "graph2",
    title: "Análisis por sexo",
    menuTitle: "\u2022 Sexo",
    text: `En 2023, un 55% de los niños pintó o escribió al menos una vez por semana en el último mes, y un 52% de las niñas. Además, a los niños les 
          leyeron más historias o cuentos (38% de ellos versus 35% de las niñas) y con los niños cantaron o tocaron un instrumento al menos una vez por 
          semana en mayor proporción que con las niñas (36% de los niños y 32% de las niñas).`,
    link: "https://public.flourish.studio/visualisation/23731590/embed",
  },
  {
    id: "graph3",
    title: "Análisis por dependencia administrativa",
    menuTitle: "\u2022 Dependencia",
    text: `La dependencia administrativa puede ser utilizada como una aproximación del nivel socioeconómico de los hogares en que viven niñas y 
          niños. La evidencia en Chile da cuenta de que la educación pública tiende a concentrar a estudiantes de mayor vulnerabilidad socioeconómica, 
          mientras que la particular subvencionada presenta una mayor variabilidad y, en algunos casos, una mayor concentración de estudiantes 
          de clase media y alta[5]. 
          Los resultados muestran que, en 2023, un 49% de las niñas y niños de colegios públicos pintó o escribió al menos una vez por semana, un 
          31% cantó o tocó un instrumento, y un 33% escuchó cuentos o historias. En cambio, un 56% de las niñas y niños de colegios subvencionados 
          pintó o escribió al menos una vez por semana, un 36% cantó o tocó un instrumento al menos una vez por semana, y un 39% escuchó cuentos 
          o historias.`,
    link: "https://public.flourish.studio/visualisation/23732086/embed",
  },
  {
    id: "graph4",
    title: "Análisis por situación de hacinamiento",
    menuTitle: "\u2022 Hacinamiento",
    text: `Cuando las niñas y los niños crecen en hogares con hacinamiento, tienen menos oportunidades de realizar actividades como pintar, cantar o 
          escuchar cuentos semanalmente. Mientras que un 55% de las niñas y niños que no viven en hacinamiento pintaron o escribieron al menos una 
          vez por semana, un 48% de las niñas y niños que viven en hacinamiento lo hicieron.`,
    link: "https://public.flourish.studio/visualisation/23732572/embed",
  },
  {
    id: "graph5",
    title: "Análisis por disponibilidad de espacio para jugar",
    menuTitle: "\u2022 Espacio para jugar",
    text: `Las niñas y niños que no cuentan con un espacio para jugar en su hogar, pintan y escriben menos que quienes sí tienen espacios, también 
          cantan y tocan menos instrumentos, y les leen menos cuentos e historias. En los últimos años, ha disminuido la proporción de niñas y niños 
          con espacios adecuados para jugar en sus hogares, reflejando cambios en las condiciones de vida que afectan el ejercicio de su derecho 
          al juego y la recreación.`,
    link: "https://public.flourish.studio/visualisation/23731829/embed",
  },
  {
    id: "graph6",
    title: "Análisis por cercanía de espacios públicos de recreación",
    menuTitle: "\u2022 Cercanía de espacios",
    text: `Las niñas y niños que viven en viviendas que se encuentran más cercanos a espacios de recreación realizan en mayor proporción actividades 
          como pintar, escribir, cantar, tocar instrumentos con una frecuencia de al menos una vez a la semana.`,
    link: "https://public.flourish.studio/visualisation/23732620/embed",
  },
  /* Exterior */
  {
    id: "graph7",
    title: "Evolución en el tiempo",
    menuTitle: "Exterior",
    text: `Es alentador observar que en 2023 (31%) una proporción mayor de niñas y niños realizó actividades deportivas al menos una vez a la semana 
          que en 2017 (27%). No obstante, la participación en actividades culturales es baja y ha tendido a bajar en los últimos años: 1 de cada 10 
          niñas y niños asiste a una actividad de este tipo al menos una vez a la semana. Por otro lado, 1 de cada 3 niñas y niños juega semanalmente 
          con otras niñas y niños en su barrio (32%), cifra que se sostiene desde el año 2017, con excepción del 2020, probablemente por el 
          confinamiento en el contexto de la pandemia. Por último, un 42% de las niñas y niños asiste al menos una vez a la semana a una plaza o 
          parque para jugar.`,
    link: "https://public.flourish.studio/visualisation/23729914/embed",
  },
  {
    id: "graph8",
    title: "Análisis por sexo",
    menuTitle: "\u2022 Sexo",
    text: `En 2023, los niños participan en mayor proporción de actividades deportivas de forma semanal que las niñas (33% contra un 29%). En el 
          caso de las actividades culturales, la proporción de niñas y niños es similar (14% y 13%, respectivamente). Esta paridad se observa también 
          en el juego de barrio (33% niñas y 32% niños) y en las visitas a plazas o parques, con cifras muy cercanas (42% y 43%).`,
    link: "https://public.flourish.studio/visualisation/23732169/embed",
  },
  {
    id: "graph9",
    title: "Análisis por dependencia administrativa",
    menuTitle: "\u2022 Dependencia",
    text: `Las niñas y niños que asisten a establecimientos educacionales subvencionados realizan en mayor proporción actividades deportivas en 
          una frecuencia de al menos una vez por semana (en comparación a quienes asisten a establecimientos educacionales públicos). Esta misma 
          tendencia se observa en cuanto a la frecuencia de la participación en actividades culturales, juego en el barrio con niñas y niños, y 
          juego en plazas y parques.`,
    link: "https://public.flourish.studio/visualisation/23731976/embed",
  },
  {
    id: "graph10",
    title: "Análisis por situación de hacinamiento",
    menuTitle: "\u2022 Hacinamiento",
    text: `Niñas y niños que no viven en hacinamiento realizan menos actividades deportivas de forma semanal que quienes sí viven en hacinamiento. 
          En 2023, la mayor brecha entre ambos grupos se da en la participación en actividades deportivas: mientras que un 32% de las niñas y niños 
          en hogares no hacinados ha realizado esta actividad más de 4 veces en el último mes, un 27% de las niñas y niños en hogares hacinados 
          lo hizo.`,
    link: "https://public.flourish.studio/visualisation/23732346/embed",
  },
  {
    id: "graph11",
    title: "Análisis por disponibilidad de espacio para jugar",
    menuTitle: "\u2022 Espacio para jugar",
    text: `Las niñas y niños que no cuentan con un espacio para jugar en su hogar, realizan en menor proporción actividades deportivas en una 
          frecuencia de al menos una vez por semana (en comparación a quienes sí cuentan con este espacio, ya sea de forma permanente o transitoria). 
          Esta misma tendencia se observa en cuanto a la frecuencia de la participación en actividades culturales, juego en el barrio con niñas 
          y niños, y juego en plazas y parques.`,
    link: "https://public.flourish.studio/visualisation/23732442/embed",
  },
  {
    id: "graph12",
    title: "Análisis por cercanía de espacios públicos de recreación",
    menuTitle: "\u2022 Cercanía de espacios",
    text: `Las niñas y niños que viven en viviendas que se encuentran más cercanos a espacios de recreación realizan en mayor proporción actividades 
          deportivas, culturales, y juego con otras niñas y niños en el barrio, y/o en plazas y parques. En este punto, es importante recordar que 
          un 90% de las niñas y niños viven en Chile en entornos urbanos, y que en estos espacios la disponibilidad de espacios de recreación se 
          encuentra altamente vinculado con el ingreso de los hogares.`,
    link: "https://public.flourish.studio/visualisation/23732227/embed",
  }
];

const App = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState("graph1");

  const handleMenuItemClick = (graphId, graphTitle) => {
    setSelectedMenuItem(graphId);
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const selectedGraph = graphs.find((graph) => graph.id === selectedMenuItem);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        width={250}
        collapsible
        collapsed={collapsed}
        onCollapse={toggleCollapsed}
        style={{ background: "#fff" }}
        breakpoint="lg"
        collapsedWidth={0}
      >
        <Menu theme="dark" mode="vertical" selectedKeys={[selectedMenuItem]} style={{ background: "#fff" }}>
          {graphs.map((graph) => (
            <Menu.Item
              key={graph.id}
              onClick={() => handleMenuItemClick(graph.id)}
              style={{ 
                color: 'black', 
                paddingLeft: ["graph1", "graph7"].includes(graph.id) ? "20px" : "30px",
              }}
            >
              {graph.menuTitle}
            </Menu.Item>
          ))}
        </Menu>
      </Sider>
      <Layout style={{ padding: "24px 24px 24px" }}>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item></Breadcrumb.Item>
        </Breadcrumb>
        <Content
          id="content"
          style={{
            background: "#ffff",
            padding: 24,
            margin: 0,
            minHeight: 280,
          }}
        >
          {selectedGraph && (
            <div>
              <div style={{ marginBottom: 16 }}>
                <h1>{selectedGraph.title}</h1>
              </div>
              <div>{selectedGraph.text}</div>
              <iframe
                src={selectedGraph.link}
                frameBorder="0"
                scrolling="no"
                style={{ minWidth: "100%", height: "500px" }}
              ></iframe>
            </div>
          )}
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;
